import { gql } from '../../types/__codegen__/sanity';

export const GET_BLOG_POST = gql(`
  query getArticle($identifier: String) {
    allArticle(where: { identifier: { current: { eq: $identifier } } }) {
      ...BlogPostFields
    }
  }
`);

export const GET_LATEST_BLOG_POSTS = gql(`
  query getLatestArticles($limit: Int = 3, $offset: Int = 0) {
    allArticle(limit: $limit, offset: $offset, sort: { _createdAt: DESC }) {
      ...BlogPostFields
    }
  }
`);

export const GET_LATEST_BLOG_POSTS_BY_TYPE = gql(`
  query getArticlesByType($limit: Int = 3, $type: String, $offset: Int = 0) {
    allArticle(
      limit: $limit
      offset: $offset
      sort: { _createdAt: DESC }
      where: { insuranceType: { identifier: { current: { eq: $type } } } }
    ) {
      ...BlogPostFields
    }
  }
`);
